export default function Arrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="105.432"
      height="95.939"
      viewBox="0 0 105.432 95.939"
    >
      <g transform="translate(87.841 0.359) rotate(-13)">
        <path
          d="M-5.419,0-7.148,6.71,0,9.25"
          transform="translate(-82.955 66.825)"
          fill="none"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M0,0C-5.569,21.084-27.392,38.58-46.594,47.223c-3,1.349-11.525,3.724-15.092.384C-75.418,34.75-39.375,10.429-36.88,35.435A24.186,24.186,0,0,1-37.95,45.973,21.408,21.408,0,0,1-44.511,55.4C-47.986,58.47-57.786,63.23-60.7,64.435c-13.046,5.4-16.349,5.81-29.057,9.014"
          transform="translate(-0.113 0.084)"
          fill="none"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}
